import React, { CSSProperties, ReactNode } from 'react';
import DialogBase from '../../../base/DialogBase/DialogBase';
import styles from './DeleteProjectHealthChecksDialog.module.css';
import { useDeleteProjectHealthChecksMutation } from '../../../generated/graphql';

type DeleteProjectHealthChecksDialogProps = {
    onClose: () => void,
    healthCheckId: string,
    id: string,
    visible: boolean,
    style?: CSSProperties | undefined,
    children?: ReactNode | undefined,
};

const DeleteProjectHealthChecksDialog = (props: DeleteProjectHealthChecksDialogProps) => {
    const { id, healthCheckId, style, visible, onClose } = props;
    const [deleteProjectHealthChecks, deleteProjectHealthChecksResult] = useDeleteProjectHealthChecksMutation({
        variables: {
            id: id,
            ids: [healthCheckId]
        }
    });

    const handleOnOkClick = () => {
        deleteProjectHealthChecks()
            .then(() => onClose())
            .catch(err => onClose());
    };

    return (
        <DialogBase
            title="Delete Project Health Check"
            type="OkCancel"
            isLoading={deleteProjectHealthChecksResult.loading}
            visible={visible}
            onClose={onClose}
            onOkClick={handleOnOkClick}
            className={styles.DeleteProjectHealthChecksDialog}
            style={style}
            data-testid="DeleteProjectHealthChecksDialog">
            <p style={{ color: "var(--text-secondary)" }}>Are you sure you want to delete this Health Check?</p>
        </DialogBase>
    );
};

export default DeleteProjectHealthChecksDialog;